import React from 'react';

export default class SkeletonOffers extends React.Component {
  render() {
    return (
      <section className="offers">
        <article className="wrapper offers-wrapper">
          {Array.from({ length: 6 }).map((_, index) => (
            <div className="offer-item skeleton" key={index}>
              <figure className="skeleton-img" />
              <figcaption className="skeleton-text" />
            </div>
          ))}
        </article>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./app/javascript/pages/home/components/offers_section/skeleton-offers.jsx